// Backend Node.js - cambiar según tu configuración
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:3001/api';

// URL base para archivos (uploads)
export const SERVER_URL = process.env.NODE_ENV === 'production'
  ? ''
  : 'http://localhost:3001';

async function request(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;

  const config = {
    headers: {
      ...options.headers,
    },
    ...options,
  };

  if (!(options.body instanceof FormData)) {
    config.headers['Content-Type'] = 'application/json';
  }

  if (config.body && typeof config.body === 'object' && !(config.body instanceof FormData)) {
    config.body = JSON.stringify(config.body);
  }

  try {
    const response = await fetch(url, config);
    const text = await response.text();
    let data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch (_) {
      console.error('[API] Respuesta no JSON:', response.status, url);
      console.error('[API] Body:', text?.slice(0, 500));
      throw new Error(`API devolvió no-JSON (${response.status}): ${text?.slice(0, 100)}...`);
    }

    if (!response.ok) {
      console.error('[API] Error:', response.status, url);
      console.error('[API] Mensaje:', data?.error);
      if (data?.debug) {
        console.warn('[API] Debug conexión:', data.debug);
        console.warn('[API] DB_SERVER:', data.debug.DB_SERVER);
        console.warn('[API] DB_DATABASE:', data.debug.DB_DATABASE);
        console.warn('[API] DB_USER:', data.debug.DB_USER);
        console.warn('[API] DB_PASSWORD:', data.debug.DB_PASSWORD);
        console.warn('[API] .env existe:', data.debug.env_exists);
      }
      throw new Error(data.error || 'Error en la petición');
    }

    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
}

export const receptionsAPI = {
  getAll: ({ search, supplier, ir, oc, dateFrom, dateTo } = {}) => {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (supplier) params.set('supplier', supplier);
    if (ir) params.set('ir', ir);
    if (oc) params.set('oc', oc);
    if (dateFrom) params.set('date_from', dateFrom);
    if (dateTo) params.set('date_to', dateTo);
    const qs = params.toString();
    return request(`/receptions${qs ? '?' + qs : ''}`);
  },
  getById: (id) => request(`/receptions?id=${id}`),
  create: (data) => request('/receptions', { method: 'POST', body: data }),
  update: (id, data) => request(`/receptions?id=${id}`, { method: 'PUT', body: data }),
  delete: (id) => request(`/receptions?id=${id}`, { method: 'DELETE' }),
  getComparison: (id) => request(`/receptions/comparison?id=${id}`),
};

export const invoicesAPI = {
  // Órdenes de Recepción
  getReceptionOrders: (receptionId) => request(`/reception_orders?reception_id=${receptionId}`),
  addReceptionOrder: (data) => request('/reception_orders', {
    method: 'POST',
    body: data,
  }),
  deleteReceptionOrder: (id) => request(`/reception_orders?id=${id}`, {
    method: 'DELETE',
  }),

  // Informes de Recepción (Multi-IR)
  searchReceptionReports: (params) => {
    const query = new URLSearchParams(params).toString();
    return request(`/reception_report/search?${query}`);
  },
  linkReceptionReport: (data) => request('/reception_report/link', {
    method: 'POST',
    body: data,
  }),
  unlinkReceptionReport: (data) => request('/reception_report/unlink', {
    method: 'POST',
    body: data,
  }),

  // Facturas
  getInvoices: (receptionId) => request(`/invoices?reception_id=${receptionId}`),
  uploadInvoice: (formData) => request('/invoices', {
    method: 'POST',
    body: formData,
  }),
  update: (id, data) => request(`/invoices?id=${id}`, { method: 'PUT', body: data }),
  delete: (id) => request(`/invoices?id=${id}`, { method: 'DELETE' }),
};

export const purchaseOrdersAPI = {
  getAll: (filters = {}) => {
    const params = new URLSearchParams(filters);
    return request(`/purchase_orders?${params}`);
  },
  getDetail: (headerId) => request(`/purchase_orders?header_id=${headerId}`),
};

export const receptionOrdersAPI = {
  getByReception: (receptionId) => request(`/reception_orders?reception_id=${receptionId}`),
  add: (data) => request('/reception_orders', { method: 'POST', body: data }),
  remove: (id) => request(`/reception_orders?id=${id}`, { method: 'DELETE' }),
};

export const receptionReportAPI = {
  generate: (data) => request('/reception_report', { method: 'POST', body: data }),
  addDetail: (data) => request('/reception_report', { method: 'PUT', body: data }),
  getDetail: (irId) => request(`/reception_report/details?ir_id=${irId}`),
  getRelatedIRsForOC: (ocId) => request(`/oc/${ocId}/irs`),
  valorize: (receptionId) => request('/reception_report?action=valorize', {
    method: 'POST',
    body: { reception_id: receptionId }
  }),
};

export const suppliersAPI = {
  search: (searchTerm, limit = 20) => request(`/suppliers?search=${encodeURIComponent(searchTerm)}&limit=${limit}`),
  getAll: () => request('/suppliers?limit=5000'),
};

export const authAPI = {
  login: (usuario, password) => request('/auth/login', {
    method: 'POST',
    body: { usuario, password }
  }),
};

/** Llama al endpoint de debug y hace log en consola (server, database, user, password enmascarado). */
export async function debugConnection() {
  const url = `${API_BASE_URL}/debug_connection`;
  try {
    const r = await fetch(url);
    const data = await r.json();
    console.warn('[scanner3] Debug conexión:', data?.debug || data);
    if (data?.debug) {
      console.warn('[scanner3] DB_SERVER:', data.debug.DB_SERVER);
      console.warn('[scanner3] DB_DATABASE:', data.debug.DB_DATABASE);
      console.warn('[scanner3] DB_USER:', data.debug.DB_USER);
      console.warn('[scanner3] DB_PASSWORD:', data.debug.DB_PASSWORD);
      console.warn('[scanner3] .env existe:', data.debug.env_exists);
    }
    if (data?.connection) {
      console.warn('[scanner3] Conexión intentada:', data.connection.ok ? 'OK' : 'FAIL', data.connection.error || '');
    }
    return data;
  } catch (e) {
    console.error('[scanner3] Debug conexión fetch failed:', e);
    return null;
  }
}
